import { render, staticRenderFns } from "./noticeTips.vue?vue&type=template&id=e5023690&scoped=true"
import script from "./noticeTips.vue?vue&type=script&lang=ts"
export * from "./noticeTips.vue?vue&type=script&lang=ts"
import style0 from "./noticeTips.vue?vue&type=style&index=0&id=e5023690&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5023690",
  null
  
)

export default component.exports